<template>
  <el-dialog
    class="min-w-330px"
    width="30%"
    :lock-scroll="false"
    :append-to-body="true"
    align-center
  >
    <template #header>
      <div class="fs-20px fw-500">
        進出場條碼
      </div>
    </template>
    <div class="fs-base">
      <div class="row g-0 p-3">
        <div class="col-12 text-center mb-3">
          進出場管皆需掃描條碼，<br>無法進出時請洽詢工作人員
        </div>
        <div class="col-sm-8 text-center mx-auto">
          <div class="ratio ratio-1x1 mx-auto mb-3 w-75">
            <div v-show="qrCodeRegenLoading" class="d-flex">
              <div class="spinner-border text-primary m-auto"></div>
            </div>
            <img v-show="!qrCodeRegenLoading" class="w-100" :src="qrCode" alt="qrCode">
          </div>
          <div class="fw-500 mb-2">
            <span v-if="countdown">
              條碼有效期限<span class="text-danger mx-1">{{ countdown }}</span>秒
            </span>
            <span v-else>條碼效期已過，請重刷</span>
          </div>
          <button
            @click="getQR()"
            type="button"
            class="btn btn-outline-secondary w-100"
            :disabled="qrCodeRegenLoading"
          >
            <i class="bi bi-arrow-repeat me-2"></i>重刷 QR code
          </button>
        </div>
      </div>
      <div class="bg-secondary-50 fs-14px p-3">
        <p class="mb-1">無法入場嗎？ 可能是因為以下原因：</p>
        <ol class="ps-3 mb-0">
          <li>QR code 逾時，請點擊重新產生新的 QR code。</li>
          <li>
            購買方案為租借場地或是報名課程，入場時間為時段前一個小時，現在並非入場時間，請在可入場時段區間內入場。
          </li>
          <li>無法成功，請洽現場工作人。</li>
        </ol>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { getUserId } from '@/utils/auth'
import { ConvertVirtualPathToRealPath } from '@/utils/urlHelper'

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API.replace(/\/$/, ''),
      memberId: 0,
      countdown: '60',
      qrCode: '',
      qrCodeRegenLoading: false
    }
  },
  mounted() {
    this.memberId = parseInt(getUserId(), 10)
  },
  methods: {
    convertVirtualPathToRealPath(baseUrl, fileUrl) {
      return ConvertVirtualPathToRealPath(baseUrl, fileUrl)
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.stopTimer()
        }
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    async getQR() {
      if (this.qrCodeRegenLoading) {
        return
      }
      this.qrCodeRegenLoading = true
      this.qrCodeRegenLoading = true
      this.stopTimer()
      this.countdown = 60
      const params = { memberId: this.memberId }
      const qrCodeUrl = '/api/web/member/get-qrcode'
      const qrCodePath = this.convertVirtualPathToRealPath(this.baseUrl, qrCodeUrl)
      try {
        const { data } = await axios.get(
          qrCodePath,
          {
            params,
            responseType: 'blob'
          }
        )
        const imageUrl = URL.createObjectURL(data)
        this.qrCode = imageUrl
        this.qrCodeRegenLoading = false
      } catch (error) {
        console.error('Failed to fetch QR code:', error)
        this.qrCodeRegenLoading = false
      }
      this.startTimer()
    }
  }
}
</script>
